export class BaseUrl {
    //name="http://localhost:8000"
    //name="http://5.39.67.23:8088"
    name="http://192.168.1.100:8088"
 }